import TextArea from "../../Testimonial/TestimonialOrders/TestiReview/textArea";
import ReactStars from "react-rating-stars-component";
import { Col, Row } from "react-bootstrap";
import React, { useState } from "react";
import "./reviewstars.css";

export const Reviewstars = (props) => {
  const [reviewVal, setReviewVal] = useState(0);
  const ratingChanged = (newRating) => {
    setReviewVal(parseFloat(newRating));
  };

  return (
    <>
      <Row className="reviewProduct">
        <Col xs="12" md="4"  lg="3" xl="auto" >
          <div className="titleReviewStars">Rate this Flower:</div>
          <ReactStars
            count={5}
            onChange={ratingChanged}
            size={28}
            isHalf={true}
            classNames={"reviewStars"}
            a11y={true}
            emptyIcon={<i className="far fa-star"></i>}
            halfIcon={<i className="fa fa-star-half-alt"></i>}
            fullIcon={<i className="fa fa-star"></i>}
            activeColor="#ffd700"
            value={reviewVal}
          />
        </Col>
        <Col xs="12" md="4"  lg="9" xl="auto">
          <TextArea id={props.id} />
        </Col>
      </Row>
      <input type="hidden" name={"review_" + props.id} value={reviewVal} />
    </>
  );
};
export default Reviewstars;
